import { useTranslations } from '@/lib/i18n-client';

// Typed translation hooks for each namespace
export const useCommonTranslations = () => useTranslations('common');
export const useAuthTranslations = () => useTranslations('auth');
export const useDashboardTranslations = () => useTranslations('dashboard');
export const useTasksTranslations = () => useTranslations('tasks');
export const useNavigationTranslations = () => useTranslations('navigation');
export const useTimerTranslations = () => useTranslations('timer');
export const useComponentsTranslations = () => useTranslations('components');
export const useBillingTranslations = () => useTranslations('billing');
export const useCalendarTranslations = () => useTranslations('calendar');
export const useOnboardingTranslations = () => useTranslations('onboarding');
export const useSettingsTranslations = () => useTranslations('settings');
export const useProjectsTranslations = () => useTranslations('projects');
export const useOrganizationsTranslations = () => useTranslations('organizations');

// Generic hook with namespace parameter
export const useNamespacedTranslations = (namespace: string) => useTranslations(namespace);
